/* Guide and native Shopify contact-form enhancements. No external services. */
(() => {
  // Shopify reserves /shop; keep the requested short URL connected to the catalog.
  if (window.location.pathname.replace(/\/+$/, '') === '/shop') {
    window.location.replace('/collections/all' + window.location.search + window.location.hash);
    return;
  }
  function initialize(root = document) {
    root.querySelectorAll('[data-rsti-guide-filters]').forEach(filters => {
      if (filters.dataset.ready) return;
      filters.dataset.ready = 'true';
      const library = filters.closest('#model-library');
      const search = filters.querySelector('input[type="search"]');
      const market = filters.querySelector('select');
      const cards = [...library.querySelectorAll('.guide-model')];
      const directory = [...library.querySelectorAll('.guide-directory li')];
      const status = library.querySelector('.guide-result');
      const empty = document.createElement('p');
      empty.className = 'guide-empty'; empty.hidden = true;
      empty.textContent = 'No matching models. Try a different search or reset the filters.';
      library.append(empty);
      function filter() {
        const term = search.value.trim().toLowerCase();
        const visible = new Set();
        cards.forEach(card => {
          const matches = (market.value === 'All' || card.dataset.market === market.value) && card.textContent.toLowerCase().includes(term);
          card.hidden = !matches; if (matches) visible.add(card.id);
        });
        directory.forEach(li => {li.hidden = !visible.has(li.querySelector('a').getAttribute('href').slice(1));});
        status.textContent = `${visible.size} of ${cards.length} models`;
        empty.hidden = visible.size > 0;
        const more = library.querySelector('.guide-more-heading');
        if (more) more.hidden = !cards.some(c => c.classList.contains('guide-model-compact') && !c.hidden);
      }
      search.addEventListener('input', filter); market.addEventListener('change', filter);
      filters.querySelector('button').addEventListener('click', () => {search.value = ''; market.value = 'All'; filter(); search.focus();});
    });
    root.querySelectorAll('form[data-rsti-submission]').forEach(form => {
      if (form.dataset.ready) return;
      form.dataset.ready = 'true';
      const photos = form.querySelector('[name="contact[Photo links]"]');
      function validatePhotos() {
        const lines = photos.value.split(/\r?\n/).map(x => x.trim()).filter(Boolean);
        const valid = lines.length > 0 && lines.length <= 5 && lines.every(value => {try {return ['http:', 'https:'].includes(new URL(value).protocol);} catch {return false;}});
        photos.setCustomValidity(valid ? '' : 'Enter one to five complete http or https photo links, one per line.');
      }
      if (photos) {photos.addEventListener('input', validatePhotos);form.addEventListener('submit', event => {validatePhotos();if (!form.reportValidity()) event.preventDefault();});}
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize()); else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
